import React from "react";

const PrintableLeadForm = () => {
  return (
    <div className="bg-white text-black min-h-screen font-sans p-8 print:p-0">
        <style>
            {`
                @media print {
                    @page { margin: 0; size: A4; }
                    body { margin: 1cm; -webkit-print-color-adjust: exact; }
                    .no-print { display: none; }
                }
            `}
        </style>

        <div className="max-w-[21cm] mx-auto border border-gray-300 p-8 shadow-sm print:shadow-none print:border-0 print:w-full print:max-w-none">
            
            {/* Header */}
            <div className="flex justify-between items-center mb-8 border-b-2 border-black pb-4">
                <div>
                    <h1 className="text-3xl font-black uppercase tracking-widest mb-1">New Lead Capture</h1>
                    <p className="text-sm text-gray-500 uppercase tracking-wide">Internal Use Only</p>
                </div>
                <div className="text-right">
                    <h2 className="text-xl font-bold uppercase tracking-widest text-gray-400">Dreibach Trade</h2>
                    <p className="text-xs text-gray-400 mt-1">{new Date().toLocaleDateString()}</p>
                </div>
            </div>

            {/* Admin Info - Removed Sales Agent / Date Time */}
            {/* <div className="mb-8 p-4 bg-gray-50 border border-gray-200">
                <div className="grid grid-cols-2 gap-8">
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Sales Agent</label>
                        <div className="h-8 border-b border-gray-300"></div>
                    </div>
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Date / Time</label>
                        <div className="h-8 border-b border-gray-300"></div>
                    </div>
                </div>
            </div> */}

            {/* Contact Details */}
            <div className="mb-8">
                <h3 className="text-lg font-bold uppercase border-b border-black mb-4 pb-1">Contact Details</h3>
                <div className="grid grid-cols-2 gap-6 mb-4">
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Full Name</label>
                        <div className="h-10 border border-gray-300 bg-white"></div>
                    </div>
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Job Title</label>
                        <div className="h-10 border border-gray-300 bg-white"></div>
                    </div>
                </div>
                <div className="grid grid-cols-1 gap-6 mb-4">
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Company Name</label>
                        <div className="h-10 border border-gray-300 bg-white"></div>
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-6 mb-4">
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Email</label>
                        <div className="h-10 border border-gray-300 bg-white"></div>
                    </div>
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Phone</label>
                        <div className="h-10 border border-gray-300 bg-white"></div>
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-6">
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Website</label>
                        <div className="h-10 border border-gray-300 bg-white"></div>
                    </div>
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Country / Region</label>
                        <div className="h-10 border border-gray-300 bg-white"></div>
                    </div>
                </div>
            </div>

            {/* Business Profile */}
            <div className="mb-8">
                <h3 className="text-lg font-bold uppercase border-b border-black mb-4 pb-1">Business Profile</h3>
                <div className="grid grid-cols-3 gap-6 mb-4">
                    <div>
                        <label className="block text-xs font-bold uppercase mb-2">Buyer Type</label>
                        <div className="space-y-2">
                            <div className="flex items-center gap-2"><div className="w-4 h-4 border border-gray-400"></div> <span className="text-sm">Wholesaler</span></div>
                            <div className="flex items-center gap-2"><div className="w-4 h-4 border border-gray-400"></div> <span className="text-sm">Retailer</span></div>
                            <div className="flex items-center gap-2"><div className="w-4 h-4 border border-gray-400"></div> <span className="text-sm">Distributor</span></div>
                        </div>
                    </div>
                    <div>
                        <label className="block text-xs font-bold uppercase mb-2">Sales Channels</label>
                        <div className="space-y-2">
                            <div className="flex items-center gap-2"><div className="w-4 h-4 border border-gray-400"></div> <span className="text-sm">Physical Store</span></div>
                            <div className="flex items-center gap-2"><div className="w-4 h-4 border border-gray-400"></div> <span className="text-sm">Online / E-com</span></div>
                            <div className="flex items-center gap-2"><div className="w-4 h-4 border border-gray-400"></div> <span className="text-sm">Marketplace</span></div>
                        </div>
                    </div>
                    <div>
                        <label className="block text-xs font-bold uppercase mb-2">Store Count</label>
                        <div className="h-10 border border-gray-300 bg-white"></div>
                    </div>
                </div>
            </div>

            {/* Interest */}
            <div className="mb-8">
                <h3 className="text-lg font-bold uppercase border-b border-black mb-4 pb-1">Interest</h3>
                <div className="mb-4">
                    <label className="block text-xs font-bold uppercase mb-2">Brand Interest</label>
                    <div className="flex gap-4 flex-wrap">
                        {["Pelle & Sol", "Yum Yum", "La Donna", "GloBrite", "Tanness", "Fur & Bone"].map(b => (
                            <div key={b} className="flex items-center gap-2 mr-4">
                                <div className="w-4 h-4 border border-gray-400"></div> <span className="text-sm">{b}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-6">
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Est. Volume</label>
                        <div className="h-10 border border-gray-300 bg-white"></div>
                    </div>
                    <div>
                        <label className="block text-xs font-bold uppercase mb-1">Order Timing</label>
                        <div className="h-10 border border-gray-300 bg-white"></div>
                    </div>
                </div>
            </div>

            {/* Notes */}
            <div className="mb-8 flex-grow">
                <h3 className="text-lg font-bold uppercase border-b border-black mb-4 pb-1">Notes / Next Steps</h3>
                <div className="h-64 border border-gray-300 bg-white" style={{backgroundImage: 'linear-gradient(transparent 95%, #eee 95%)', backgroundSize: '100% 2rem'}}></div>
            </div>

            {/* Footer */}
            <div className="text-center text-xs text-gray-400 uppercase tracking-widest mt-12 pt-4 border-t border-gray-200">
                Dreibach Group • Unit 2, Capital Business Park, Borehamwood
            </div>

            {/* Print Button (Hidden in Print) */}
            <div className="fixed bottom-8 right-8 no-print">
                <button 
                    onClick={() => window.print()}
                    className="bg-black text-white px-6 py-3 rounded shadow-lg font-bold uppercase tracking-widest hover:bg-gray-800 transition-colors"
                >
                    Print Form
                </button>
            </div>
        </div>
    </div>
  );
};

export default PrintableLeadForm;
